/**
* Ajax Results JS
* -----------------------------------------------------------------------------
*
* All the JS for the Ajax Results component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'ajax-results',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      /*
       * The point of all this is to prevent weird reorganization
       * of images with the column-count while images are loading.
       * So instead, we'll load all of the images first, and then
       * add column-count to the parent.
       */

      let imagesLoaded = 0;
      const totalImages = $( '.ajax-results__result' ).length;

      $( '.ajax-results__result img' ).each( function( idx, img ) {
        $( '<img>' ).on( 'load', imageLoaded ).attr( 'src', $( img ).attr( 'src' ) );
      } );

      function imageLoaded() {
        imagesLoaded++;
        if ( imagesLoaded == totalImages ) {
          allImagesLoaded();
        }
      }

      function allImagesLoaded() {
        $( '.ajax-results' ).addClass( 'img-loaded' );
      }

      // --------------------

      $( '.ajax-results__result a' ).magnificPopup( {
        type: 'inline',
        gallery: {
          enabled: true,
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'ajax-results', COMPONENT );
} )( app );
